import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { MauSoHoaDon, MauSoHoaDonInput } from '@/types/schemas/mau-so-hoa-don.type';
import { FormSchema, initialFormValues, type FormValues } from '../schema';
import { NhomLoaiHD } from '@/types/schemas/nhom-loai-hd.type';
import BasicInfoTab from './BasicInfoTab';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: MauSoHoaDonInput) => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: MauSoHoaDon | null;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: FormDialogProps) => {
  const [nhomLoaiHD, setNhomLoaiHD] = useState<NhomLoaiHD | null>(initialData?.nhom_loai_hd_data || null);

  const handleSubmit = async (data: FormValues) => {
    const formData: MauSoHoaDonInput = {
      ...data,
      nhom_loai_hd: nhomLoaiHD?.uuid || ''
    };
    await onSubmit(formData);
  };

  const getTitle = () => {
    switch (formMode) {
      case 'add':
        return 'Thêm mẫu số hóa đơn';
      case 'edit':
        return 'Sửa mẫu số hóa đơn';
      case 'view':
        return 'Xem mẫu số hóa đơn';
      default:
        return 'Mẫu số hóa đơn';
    }
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={getTitle()}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2<FormValues>
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialFormValues) as Partial<FormValues>}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={
            <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
              <BasicInfoTab formMode={formMode} nhomLoaiHD={nhomLoaiHD} setNhomLoaiHD={setNhomLoaiHD} />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
